import React from 'react';
import { BarChart3, Layers, GitCompare, Zap, MessageSquare, Users, ShieldAlert, LineChart } from 'lucide-react';
import type { ActiveTab } from '../../types';
import { useForecastV3 } from '../../context/ForecastV3Context';

interface TabConfig {
  id: ActiveTab;
  label: string;
  icon: React.ComponentType<{ size?: number }>;
}

export const FORECAST_TABS: TabConfig[] = [
  { id: 'workspace', label: 'Workspace', icon: BarChart3 },
  // { id: 'labor', label: 'Labor', icon: Users },  // Hidden for now
  { id: 'versions', label: 'Versions', icon: Layers },
  { id: 'compare', label: 'Compare', icon: GitCompare },
  { id: 'risk', label: 'Risk', icon: ShieldAlert },
  { id: 'analytics', label: 'Analytics', icon: LineChart },
  // { id: 'health', label: 'Setup & Health', icon: Zap },  // Hidden for now
  { id: 'notes', label: 'Notes', icon: MessageSquare },
];

export function ModuleNav() {
  const { state, setActiveTab } = useForecastV3();
  const { activeTab } = state;

  return (
    <div className="fv3-tabs px-4" style={{ background: 'var(--lodge-white)', borderBottom: '1px solid var(--lodge-onyx-100)' }}>
      <div className="flex items-center gap-1">
        {FORECAST_TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`fv3-tab${isActive ? ' fv3-tab-active' : ''} flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors`}
              style={isActive
                ? { borderBottomColor: 'var(--lodge-orange-400)', color: 'var(--lodge-orange-500)', marginBottom: -1 }
                : { borderBottomColor: 'transparent', color: 'var(--lodge-onyx-500)', marginBottom: -1 }}
              onMouseEnter={e => { if (!isActive) (e.currentTarget as HTMLButtonElement).style.color = 'var(--lodge-onyx-800)'; }}
              onMouseLeave={e => { if (!isActive) (e.currentTarget as HTMLButtonElement).style.color = 'var(--lodge-onyx-500)'; }}
            >
              <Icon size={16} />
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ModuleNav;
